<template>
  <div>
    <div class="options-block-section">
      <!-- TRUE FALSE SECTION -->
      <div class="true-false" v-if="option_type === 'true_false'">
        <div class="title-text font-weight-bold color_grey_dark text-uppercase">
          Options <span class="brand_tonic">*</span>
        </div>

        <!-- OPTION TYPE ONE -->
        <!-- TRUE -->
        <div class="option-type-one rounded-5">
          <div class="key">True</div>
          <!-- VALUE -->
          <div class="value pointer">
            <label for="true" class="radio-inline pointer">
              <input type="radio" v-model="true_false" value="true" id="true" />
              <span class="text pointer">Correct answer</span>
            </label>
          </div>
        </div>
        <!-- FALSE -->
        <div class="option-type-one rounded-5">
          <div class="key">False</div>
          <!-- VALUE -->
          <div class="value pointer">
            <label for="false" class="radio-inline pointer">
              <input
                type="radio"
                v-model="true_false"
                value="false"
                id="false"
              />
              <span class="text pointer">Correct answer</span>
            </label>
          </div>
        </div>
        <!-- OPTION TYPE ONE -->
      </div>

      <!-- MULTICHOICE OPTIONS -->
      <div
        class="multichoice-section d-flex justify-content-between align-items-start flex-wrap"
        v-if="
          (option_type === 'multichoice' || option_type === 'multiple') &&
            action === 'create'
        "
      >
        <!-- EDITOR CONTAINER -->
        <div
          class="editor-container"
          v-for="(option, index) in multi_options"
          :key="index"
        >
          <!-- TEXT TOP ROW -->
          <div
            class="text-row d-flex justify-content-between align-items-center nowrap"
          >
            <div class="key font-weight-bold color_grey_dark text-uppercase">
              Option {{ option.id }} <span class="brand_tonic">*</span>
            </div>
            <div class="value">
              <label :for="option.id" class="radio-inline pointer">
                <input
                  type="radio"
                  v-model="multichoice"
                  :value="option.id"
                  :id="option.id"
                />
                <span
                  class="text pointer color_grey_dark position-relative mt-1 d-none d-sm-block"
                  >Correct answer</span
                >
                <span
                  class="text pointer color_grey_dark position-relative mt-1 d-sm-none"
                  >Correct</span
                >
              </label>
            </div>
          </div>

          <!-- TEXT TOP ROW -->
          <!-- EDITOR -->
          <!-- <TextEditor placeholder="Enter your answer"></TextEditor> -->
          <TextEditor
            @optionInput="handleOption"
            :action="action"
            :event_name="option.id"
            :option_id="option.id"
            v-dynamic-option-editor-events="knownEvents"
            :content="option.value"
          ></TextEditor>
        </div>
      </div>

      <!-- UPDATE ACTION -->
      <div
        class="multichoice-section d-flex justify-content-between align-items-start flex-wrap col-12"
        v-else-if="
          (option_type === 'multichoice' || option_type === 'multiple') &&
            action === 'update'
        "
      >
        <!-- EDITOR CONTAINER -->
        <div
          class="editor-container"
          v-for="(option, index) in options_content"
          :key="index"
        >
          <!-- TEXT TOP ROW -->
          <div
            class="text-row d-flex justify-content-between align-items-center nowrap"
          >
            <div class="key font-weight-bold color_grey_dark text-uppercase">
              Option {{ option.id }}
            </div>

            <div class="value">
              <label :for="option.id" class="radio-inline pointer">
                <input
                  type="radio"
                  v-model="multichoice"
                  :checked="option.correct ? 'true' : 'false'"
                  :value="option.id.toUpperCase()"
                  :id="option.id.toUpperCase()"
                />
                <span
                  class="text pointer color_grey_dark position-relative mt-1 d-none d-sm-block"
                  >Correct answer</span
                >
                <span
                  class="text pointer color_grey_dark position-relative mt-1 d-sm-none"
                  >Correct</span
                >
              </label>
            </div>
          </div>

          <!-- TEXT TOP ROW -->
          <!-- EDITOR -->
          <TextEditor
            @optionInput="handleOption"
            :action="action"
            :event_name="option.id.toUpperCase()"
            :option_id="option.id"
            v-dynamic-option-editor-events="knownEvents"
            :content="option.value"
          ></TextEditor>
        </div>
      </div>
    </div>

    <!-- MULTICHOICE OPTIONS -->

    <!-- SHORT ANSWER -->
    <div
      class="short-answer-section w-100"
      v-if="option_type === 'short_answer'"
    >
      <div class="top-row text-uppercase color_grey_dark font-weight-bold">
        Answer
      </div>
      <TextEditor placeholder="Enter your answer"></TextEditor>
    </div>
    <!-- SHORT ANSWER -->

    <!-- ESSAY -->
    <div class="essay-section" v-if="option_type === 'essay'">
      <div class="selection-input">
        <div class="key">Word Limit</div>
        <div class="line"></div>
        <input
          type="number"
          v-model="question_score"
          class="form-control number-box"
          placeholder="10"
        />
      </div>

      <!-- FILE UPLOAD -->
      <div class="file-upload">
        <label
          for="allowFile"
          class="checkbox-inline d-flex align-items-center pointer"
        >
          <input type="checkbox" id="allowFile" />
          <div class="font-13 color_grey_dark mt-1 ml-2 pointer">
            Allow File Upload
          </div>
        </label>
      </div>
    </div>
    <!-- ESSAY -->
  </div>
</template>

<script>
import TextEditor from "@/components/classComps/assessment/TextEditor";

export default {
  name: "OptionsBlock",

  directives: {
    DynamicOptionEditorEvents: {
      bind: function(el, binding, vnode) {
        const allEvents = binding.value;
        allEvents.forEach((event) => {
          // register handler in the dynamic component
          vnode.componentInstance.$on(event, (eventData) => {
            // when the event is fired, the proxyEvent function is going to be called
            // vnode.context.proxyEvent(event, eventData);
            vnode.context.handleOption(event, eventData);
          });
        });
      },
      unbind: function(el, binding, vnode) {
        vnode.componentInstance.$off();
      },
    },
  },

  components: {
    TextEditor,
  },

  props: {
    action: {
      type: String,
      default: "create",
    },
    option_type: {
      type: String,
      default: "true_false",
    },
    options_content: Array,
    option_bool_answer: [Boolean, String],
    clear: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    true_false(val) {
      console.log("TRue False", val);
      this.$emit("setAnswer", { value: val, clear: false });
    },

    multichoice(val) {
      this.$emit("setAnswer", { value: val, clear: false });
    },

    clear: {
      handler(val) {
        if (val) {
          this.true_false = "";
          this.multichoice = "";
        }
      },
    },

    option_bool_answer: {
      handler(val) {
        if (this.action == "update") {
          if (val) this.true_false = true;
          else this.true_false = false;
        }
      },
      immediate: true,
    },
  },

  mounted() {
    try {
      if (this.options_content !== undefined)
        setTimeout(() => {
          this.options_content.forEach((item) => {
            if (item.correct) this.multichoice = item.id.toUpperCase();
          });
        }, 2000);
    } catch (err) {
      console.log(err);
    }
  },

  data() {
    return {
      true_false: "",
      multichoice: "",

      multi_options: [
        {
          id: "A",
        },
        {
          id: "B",
        },
        {
          id: "C",
        },
        {
          id: "D",
        },
      ],
      dynamicProps: {
        isThisCool: true,
      },
      knownEvents: ["A", "B", "C", "D", "E"],
      // knownUpdateEvents: ['updateA', 'updateB', 'updateC', 'updateD', 'updateE'],
    };
  },

  methods: {
    handleOption(evt, opt) {
      // console.log(evt) // this holds the options
      // console.log(opt) // this holds this value
      this.$emit("getAnswer", {
        content: opt,
        answer: evt,
      }); // emmit the options and values
    },
  },
};
</script>

<style lang="scss">
.options-block-section {
  margin-bottom: 20px;
  // margin-top: -10px;

  @include breakpoint_max(xs) {
    margin-bottom: 30px;
  }

  .true-false {
    .title-text {
      font-size: 14px;
      line-height: 19px;
      margin-top: 30px;
      margin-bottom: 12px;

      @include breakpoint_max(md) {
        font-size: 13px !important;
      }

      @include breakpoint_max(sm) {
        font-size: 12px !important;
      }

      @include breakpoint_max(xs) {
        font-size: 10.75px !important;
      }
    }
  }

  .option-type-one {
    border: 1px solid $border_grey;
    margin-bottom: 10px;
    width: 370px;
    padding: 5px 6px 5px 15px;
    @include flex_row_between_nowrap;

    @include breakpoint_max(sm) {
      width: 100%;
    }

    @include breakpoint_max(xs) {
      padding: 4px;
    }

    .key {
      font-size: 14px;
      line-height: 19px;
      color: $color_grey_dark;

      @include breakpoint_max(sm) {
        font-size: 13px;
      }

      @include breakpoint_max(xs) {
        font-size: 11.75px;
        margin-left: 5px;
      }
    }

    .value {
      width: 45%;
      height: 100%;
      border-radius: 4px;
      background: $color_white;
      overflow: hidden;
      position: relative;

      @include breakpoint_max(sm) {
        width: 55%;
      }

      input {
        position: relative;
        top: 50%;
        transform: translateY(10%);
        left: 10px;

        &:before,
        &:after {
          @include equal_min_edge(18);

          @include breakpoint_max(sm) {
            @include equal_min_edge(15);
          }
        }
      }

      .text {
        position: relative;
        top: 50%;
        left: 14px;
        transform: translateY(5%);
        font-size: 14px;
        line-height: 165%;
        color: $color_grey_dark;

        @include breakpoint_max(sm) {
          font-size: 12.5px;
        }

        @include breakpoint_max(xs) {
          font-size: 11.75px;
        }
      }
    }
  }

  .multichoice-section {
    .editor-container {
      width: 48%;
      margin-bottom: 20px;

      @include breakpoint_max(md) {
        width: 100%;
      }

      .text-row {
        margin-bottom: 4px;
        font-size: 14px;
        line-height: 19px;

        .key {
          font-size: 14px;
          line-height: 19px;

          @include breakpoint_max(sm) {
            font-size: 12.5px;
          }

          @include breakpoint_max(xs) {
            font-size: 11px;
          }
        }

        .value {
          input {
            position: relative;
            top: 50%;
            transform: translateY(20%);

            &:before,
            &:after {
              @include equal_min_edge(18);

              @include breakpoint_max(sm) {
                @include equal_min_edge(13);
              }
            }
          }

          @include breakpoint_max(sm) {
            .text {
              font-size: 13px;
            }
          }

          @include breakpoint_max(xs) {
            .text {
              font-size: 11.5px;
            }
          }
        }
      }
    }
  }

  .short-answer-section {
    margin-top: -34px;

    .top-row {
      position: relative;
      top: 30px;
      font-size: 14px;
      line-height: 19px;

      @include breakpoint_max(sm) {
        font-size: 12.5px;
      }
    }
  }

  .essay-section {
    width: 205px;

    .selection-input {
      padding-left: 15px;
    }
  }
}
</style>
